import { render } from "./PhysicalNetworksTab.vue?vue&type=template&id=303cfb3a&scoped=true"
import script from "./PhysicalNetworksTab.vue?vue&type=script&lang=js"
export * from "./PhysicalNetworksTab.vue?vue&type=script&lang=js"

import "./PhysicalNetworksTab.vue?vue&type=style&index=0&id=303cfb3a&lang=scss&scoped=true"

import exportComponent from "/root/mold/diplo/dist/rpmbuild/BUILD/cloudstack-4.21.0.0-Diplo-202603161407/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-303cfb3a"]])

export default __exports__